
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const DataDeletionSection = () => {
  return (
    <Card className="border-border/50 shadow-sm">
      <CardHeader>
        <CardTitle className="text-foreground text-xl font-semibold">Data Deletion Rights</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <p>
            You have the right to request deletion of your personal data from our systems. We provide multiple 
            convenient methods for you to exercise this right and take control of your data.
          </p>
          
          <div className="space-y-5">
            <div>
              <h3 className="font-semibold text-foreground text-lg mb-3">Option 1: Account Dashboard</h3>
              <p className="mb-3">
                The quickest way to delete your data is directly through your account dashboard:
              </p>
              <ol className="list-decimal list-inside space-y-2 ml-4 text-sm">
                <li>Log into your SocialScoop account</li>
                <li>Navigate to Settings → Profile</li>
                <li>Click "Delete Account and All Data"</li>
                <li>Confirm your request and follow the verification steps</li>
              </ol>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground text-lg mb-3">Option 2: Data Deletion Portal</h3>
              <p className="mb-3">
                Use our dedicated data deletion portal for external requests:
              </p>
              <div className="bg-muted/50 p-4 rounded-lg border border-border/50">
                <a 
                  href="https://socialscoop.ai/data-deletion"
                  className="text-primary hover:underline font-medium transition-colors"
                >
                  https://socialscoop.ai/data-deletion
                </a>
              </div>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground text-lg mb-3">Option 3: Email Request</h3>
              <p className="mb-3">
                Contact our privacy team directly for personalized assistance:
              </p>
              <div className="bg-muted/50 p-4 rounded-lg border border-border/50">
                <a 
                  href="mailto:privacy@socialscoop.ai?subject=Data%20Deletion%20Request"
                  className="text-primary hover:underline font-medium transition-colors"
                >
                  privacy@socialscoop.ai
                </a>
              </div>
            </div>
          </div>
          
          <div className="mt-6 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
            <p className="text-destructive text-sm">
              <strong>Important Notice:</strong> Data deletion is permanent and cannot be undone. We will process 
              your request within 30 calendar days and send you a confirmation email once the deletion is completed. 
              Some data may be retained for legal compliance purposes as outlined in our Privacy Policy.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
